import {
    RECEIVE_SEED
} from '../../actions/randomSeedActions';

const RandomSeedReducer = (state = Math.random(), action) => {
    switch (action.type) {
        case RECEIVE_SEED:
            return action.seed;

        default:
            return state;
    }
};

export default RandomSeedReducer;